import React, { useMemo, useState } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import useStyles from './Home.styles'
import { Grid, Pagination, Tabs } from '@mantine/core'
import {
  DRINK_JPG,
  DEBUG_MODE,
  DRINK_AVIF,
  SMOKY_SPEAKER_JPG,
  SMOKY_SPEAKER_AVIF,
  SMOKY_SPEAKER_JPG_NO_PADDING,
  SMOKY_SPEAKER_AVIF_NO_PADDING,
} from '../../../utilities/config'
import { translate } from '../../../utilities/language'
import { getAttribution } from '../../../utilities/content'
import {
  SPOTIFY_ISNT_LEGAL_TITLE_HTML,
  SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE,
  SPOTIFY_ISNT_LEGAL_TITLE_HTML_ES,
  SPOTIFY_ISNT_LEGAL_TITLE_HTML_FR,
  SPOTIFY_ISNT_LEGAL_TITLE_HTML_KO,
  SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES,
  SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_FR,
  SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_KO,
  SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/spotify-isnt-legal-for-your-business-data'
import {
  SECRET_SOUNDTRACK_FORMULA_TITLE_HTML,
  SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_ES,
  SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_FR,
  SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_KO,
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE,
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES,
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_FR,
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_KO,
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/secret-soundtrack-formula-for-gyms-and-cafes-data'
import {
  HOW_THE_RIGHT_PLAYLIST_TITLE_HTML,
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE,
  HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_ES,
  HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_FR,
  HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_KO,
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES,
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR,
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO,
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/how-the-right-playlist-can-increase-restaurant-sales-data'
import {
  HOW_MUCH_TITLE_HTML,
  HOW_MUCH_ARTICLE_ROUTE,
  HOW_MUCH_TITLE_HTML_ES,
  HOW_MUCH_TITLE_HTML_FR,
  HOW_MUCH_TITLE_HTML_KO,
  HOW_MUCH_ARTICLE_ROUTE_ES,
  HOW_MUCH_ARTICLE_ROUTE_FR,
  HOW_MUCH_ARTICLE_ROUTE_KO,
  HOW_MUCH_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/how-much-is-a-music-license-for-a-small-shop-data'
import {
  HOW_MUSIC_BOOSTS_TITLE_HTML,
  HOW_MUSIC_BOOSTS_ARTICLE_ROUTE,
  HOW_MUSIC_BOOSTS_TITLE_HTML_ES,
  HOW_MUSIC_BOOSTS_TITLE_HTML_FR,
  HOW_MUSIC_BOOSTS_TITLE_HTML_KO,
  HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_ES,
  HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_FR,
  HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_KO,
  HOW_MUSIC_BOOSTS_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/how-music-boosts-productivity-data'
import {
  HOW_TO_BUILD_TITLE_HTML,
  HOW_TO_BUILD_ARTICLE_ROUTE,
  HOW_TO_BUILD_TITLE_HTML_ES,
  HOW_TO_BUILD_TITLE_HTML_FR,
  HOW_TO_BUILD_TITLE_HTML_KO,
  HOW_TO_BUILD_ARTICLE_ROUTE_ES,
  HOW_TO_BUILD_ARTICLE_ROUTE_FR,
  HOW_TO_BUILD_ARTICLE_ROUTE_KO,
  HOW_TO_BUILD_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/how-to-build-your-perfect-workplace-with-the-best-music-strategy-data'
import {
  HOME_TITLE_MARKUP,
  HOME_TITLE_MARKUP_ES,
  HOME_TITLE_MARKUP_FR,
  HOME_TITLE_MARKUP_KO,
} from '../../../static-data/index-data'
import {
  FIVE_MISTAKES_TITLE_HTML,
  FIVE_MISTAKES_TITLE_HTML_ES,
  FIVE_MISTAKES_TITLE_HTML_FR,
  FIVE_MISTAKES_TITLE_HTML_KO,
  FIVE_MISTAKES_ARTICLE_ROUTE,
  FIVE_MISTAKES_ARTICLE_ROUTE_ES,
  FIVE_MISTAKES_ARTICLE_ROUTE_FR,
  FIVE_MISTAKES_ARTICLE_ROUTE_KO,
  FIVE_MISTAKES_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/five-mistakes-businesses-make-data'
import {
  SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_ES,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_FR,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_KO,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_ES,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_FR,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_KO,
  SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_PUBLISHED_STR,
} from '../../../static-data/subscription-based-vs-traditional-data'
import {
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_PUBLISHED_STR,
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE,
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_ES,
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_FR,
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_KO,
  SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML,
  SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_ES,
  SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_FR,
  SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_KO,
} from '../../../static-data/spotify-in-coffee-shops-data'

const ReadyToTransform: React.ComponentType<any> = dynamic(
  () => import('../../controls/ReadyToTransform'),
  {
    ssr: true,
  },
)

export default function Home(props: any) {
  const { classes } = useStyles()
  const selectedLanguage: any = props?.selectedLanguage
  const avifCompatible: any = props?.avifCompatible
  const width: any = props?.width
  const [activeTab, setActiveTab] = useState<string>('featured')
  const PAGE_SIZE: number = 4
  const ARTICLE_COUNT: number = 9
  const PAGE_COUNT: number =
    ARTICLE_COUNT / PAGE_SIZE < 1
      ? 1
      : Math.floor(ARTICLE_COUNT / PAGE_SIZE) +
        ((ARTICLE_COUNT / PAGE_SIZE) % 1 > 0 ? 1 : 0)
  const [page, setPage]: any = useState<any>(1)
  const [featuredPage, setFeaturedPage]: any = useState<any>(1)
  const FEATURED_PAGE_SIZE: number = 4
  const FEATURED_ARTICLE_COUNT: number = 5
  const FEATURED_PAGE_COUNT: number =
    FEATURED_ARTICLE_COUNT / FEATURED_PAGE_SIZE < 1
      ? 1
      : Math.floor(FEATURED_ARTICLE_COUNT / FEATURED_PAGE_SIZE) +
        ((FEATURED_ARTICLE_COUNT / FEATURED_PAGE_SIZE) % 1 > 0 ? 1 : 0)

  const speakerImage = useMemo(() => {
    return (
      <Image
        width={512}
        height={372}
        sizes="(max-width: 300px) 192px, 
              (max-width: 430px) 256px, 
              (max-width: 590px) 384px, 
              512px"
        src={avifCompatible ? SMOKY_SPEAKER_AVIF : SMOKY_SPEAKER_JPG}
        alt=""
        priority={true}
        style={{
          marginTop: '30px',
          display: 'block',
          width: '100%',
          maxWidth: '512px',
          height: 'auto',
        }}
      />
    )
  }, [width, avifCompatible])

  const speakerImageNoPadding = useMemo(() => {
    return (
      <Image
        width={512}
        height={372}
        src={
          avifCompatible
            ? SMOKY_SPEAKER_AVIF_NO_PADDING
            : SMOKY_SPEAKER_JPG_NO_PADDING
        }
        alt=""
        priority={true}
        sizes="(max-width: 320px) 192px, 
         (max-width: 350px) 256px, 
         (max-width: 400px) 288px, 
         (max-width: 460px) 255px, 
         (max-width: 590px) 350px, 
         512px"
        style={{
          marginTop: '30px',
          display: 'block',
          width: '100%',
          maxWidth: '512px',
          height: 'auto',
        }}
      />
    )
  }, [width, avifCompatible])

  const drinkImage = useMemo(() => {
    return (
      <Image
        width={
          width > 590
            ? 512
            : width > 430
              ? 400
              : width > 400
                ? 384
                : width > 350
                  ? 330
                  : width > 320
                    ? 288
                    : width > 300
                      ? 256
                      : 192
        }
        height={
          width > 590
            ? 372
            : width > 430
              ? 291
              : width > 400
                ? 279
                : width > 350
                  ? 240
                  : width > 320
                    ? 210
                    : width > 300
                      ? 186
                      : 140
        }
        className={classes.imgDrink}
        src={avifCompatible ? DRINK_AVIF : DRINK_JPG}
        draggable={false}
        alt={translate(
          'Premium, Professional Background Music',
          'Música de fondo premium y profesional',
          'Musique de fond haut de gamme et professionnelle',
          '고품질의 전문적인 배경 음악',
          selectedLanguage,
        )}
        style={{
          width:
            width > 590
              ? '512px'
              : width > 430
                ? '384px'
                : width > 300
                  ? '256px'
                  : '192px',
          height:
            width > 590
              ? '512px'
              : width > 430
                ? '384px'
                : width > 300
                  ? '256px'
                  : '192px',
          objectFit: 'cover',
          borderRadius: '50%',
          maskImage:
            'radial-gradient(circle at center, rgba(17, 17, 16,1) 40%, rgba(17, 17, 16,0) 60%)',
          WebkitMaskImage:
            'radial-gradient(circle at center, rgba(17, 17, 16,1) 40%, rgba(17, 17, 16,0) 60%)',
          transform: 'scale(0.8,0.8)',
        }}
      />
    )
  }, [width, avifCompatible, selectedLanguage])

  return (
    <div className={classes.mainGrid}>
      <div className={classes.innerDiv}>
        <Grid columns={24}>
          <Grid.Col
            md={12}
            pl={width < 310 ? 5 : width < 370 ? 15 : 20}
            pr={width < 310 ? 5 : width < 370 ? 15 : 20}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <h1 className={classes.standardText + ' ' + classes.h1Tag}>
                {translate(
                  <>{HOME_TITLE_MARKUP}</>,
                  <>{HOME_TITLE_MARKUP_ES}</>,
                  <>{HOME_TITLE_MARKUP_FR}</>,
                  <>{HOME_TITLE_MARKUP_KO}</>,
                  selectedLanguage,
                )}
              </h1>
              <div
                style={{
                  display: 'flex',
                  alignItems: width < 600 ? 'center' : 'flex-start',
                  justifyContent: width < 600 ? 'center' : 'space-around',
                  flexDirection: 'column',
                  height: '100%',
                  width: width < 992 ? '100%' : 'initial',
                  minHeight: width < 992 ? 'initial' : '1000px',
                }}
              >
                {width < 992 ? speakerImageNoPadding : speakerImage}
                <br />
                {width > 991 && drinkImage}
              </div>
            </div>
          </Grid.Col>
          <Grid.Col
            md={12}
            pl={width < 310 ? 5 : width < 370 ? 15 : 20}
            pr={width < 310 ? 5 : width < 370 ? 15 : 20}
          >
            <Tabs
              defaultValue="featured"
              value={activeTab}
              onTabChange={(val: any) => {
                if (val != activeTab) {
                  setActiveTab(val)
                  if (val == 'all') setPage(1)
                  else setFeaturedPage(1)
                }
              }}
              style={{
                outline: '0',
              }}
              styles={() => ({
                outline: '0',
                root: {
                  height: width < 992 ? 'initial' : '100%',
                  outline: '0',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    outline: '0',
                  },
                },
                tabRightSection: {
                  outline: '0',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    outline: '0',
                  },
                },
                tabIcon: {
                  outline: '0',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    outline: '0',
                  },
                },
                panel: {
                  outline: '0',
                  maxWidth: '93vw',
                  height: '100%',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    outline: '0',
                  },
                },
                tabsList: {
                  width: width < 992 ? 'max-content' : 'initial',
                  flexDirection: width < 992 ? 'column' : 'row',
                  transform:
                    width > 991
                      ? 'scale(1,1)'
                      : width < 380
                        ? 'translate(0px, 20px)'
                        : 'translate(0px, 10px)',
                  maxWidth: '90vw',
                  borderBottom: 'none',
                  outline: '0',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    outline: '0',
                  },
                },
                tabLabel: {
                  color: '#ffffff',
                  fontFamily: 'Arial, sans-serif',
                  fontWeight: 'bold',
                  outline: '0',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    outline: '0',
                  },
                },
                tab: {
                  cursor: 'default',
                  borderBottom: 'none',
                  backgroundColor: 'transparent',
                  outline: '0',
                  marginBottom: '10px !important',
                  '&:focus': {
                    outline: '0',
                  },
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                },
              })}
            >
              <Tabs.List>
                <Tabs.Tab
                  value="featured"
                  icon={<></>}
                  style={{
                    borderBottom:
                      activeTab == 'featured'
                        ? '2px solid #339af0'
                        : '2px solid transparent',
                    marginRight: '20px',
                    outline: '0',
                  }}
                  className={
                    activeTab != 'featured'
                      ? classes.musicLabel
                      : classes.musicLabelNotHoverable
                  }
                >
                  <span>
                    {translate(
                      <>Featured</>,
                      <>Presentada</>,
                      <>Vedette</>,
                      <>
                        <span
                          aria-hidden={true}
                          className={classes.asianTextBlock}
                        >
                          주요
                        </span>
                      </>,
                      selectedLanguage,
                    )}
                  </span>
                </Tabs.Tab>
                <Tabs.Tab
                  value="all"
                  icon={<></>}
                  style={{
                    display: 'flex',
                    borderBottom:
                      activeTab == 'all'
                        ? '2px solid #339af0'
                        : '2px solid transparent',
                    outline: '0',
                  }}
                  className={
                    activeTab != 'all'
                      ? classes.musicLabel
                      : classes.musicLabelNotHoverable
                  }
                >
                  <span>
                    {translate(
                      <>All Stories</>,
                      <>Todos los Artículos</>,
                      <>Tous les Articles</>,
                      <>
                        <span
                          aria-hidden={true}
                          className={classes.asianTextBlock}
                        >
                          모든
                        </span>{' '}
                        <span
                          aria-hidden={true}
                          className={classes.asianTextBlock}
                        >
                          기사
                        </span>{' '}
                      </>,
                      selectedLanguage,
                    )}
                  </span>
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel
                value="featured"
                pt="xs"
                style={{
                  outline: '0',
                  height: '100%',
                }}
              >
                <>
                  <br />
                  <ul
                    className={classes.standardText + ' ' + classes.ulArticles}
                  >
                    {featuredPage == 1 ? (
                      <>
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_FR,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_ES,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_FR,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    FIVE_MISTAKES_ARTICLE_ROUTE,
                                    FIVE_MISTAKES_ARTICLE_ROUTE_ES,
                                    FIVE_MISTAKES_ARTICLE_ROUTE_FR,
                                    FIVE_MISTAKES_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              FIVE_MISTAKES_TITLE_HTML,
                              FIVE_MISTAKES_TITLE_HTML_ES,
                              FIVE_MISTAKES_TITLE_HTML_FR,
                              FIVE_MISTAKES_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            FIVE_MISTAKES_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_TO_BUILD_ARTICLE_ROUTE,
                                    HOW_TO_BUILD_ARTICLE_ROUTE_ES,
                                    HOW_TO_BUILD_ARTICLE_ROUTE_FR,
                                    HOW_TO_BUILD_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_TO_BUILD_TITLE_HTML,
                              HOW_TO_BUILD_TITLE_HTML_ES,
                              HOW_TO_BUILD_TITLE_HTML_FR,
                              HOW_TO_BUILD_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_TO_BUILD_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE,
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_ES,
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_FR,
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML,
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_ES,
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_FR,
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                      </>
                    ) : (
                      <>
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_ES,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_FR,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_FR,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_ES,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_FR,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_MUCH_ARTICLE_ROUTE,
                                    HOW_MUCH_ARTICLE_ROUTE_ES,
                                    HOW_MUCH_ARTICLE_ROUTE_FR,
                                    HOW_MUCH_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_MUCH_TITLE_HTML,
                              HOW_MUCH_TITLE_HTML_ES,
                              HOW_MUCH_TITLE_HTML_FR,
                              HOW_MUCH_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_MUCH_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                              visibility: 'hidden',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li
                          className={classes.liArticle}
                          style={{
                            visibility: 'hidden',
                          }}
                        >
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_ES,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_FR,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                      </>
                    )}
                    <li className={classes.liArticle}>
                      <br />
                      <Pagination
                        page={featuredPage}
                        sx={() => ({
                          '&:focus': {
                            outline: '0',
                          },
                        })}
                        onChange={(p: any) => {
                          try {
                            setPage(1)
                            setFeaturedPage(p)
                          } catch (e) {
                            if (DEBUG_MODE) console.log(e)
                          }
                        }}
                        styles={{
                          item: {
                            backgroundColor: '#b476eeff',
                            fontFamily: 'Arial, sans-serif',
                            color: '#ffffff',
                            borderColor: 'transparent',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            '&:hover': {
                              opacity: 0.85,
                            },
                            '&[data-active]': {
                              outline: '0',
                              pointerEvents: 'none',
                              cursor: 'default !important',
                              opacity: '1 !important',
                              fontFamily: 'Arial, sans-serif',
                              color: '#000000',
                              backgroundColor: '#339af0',
                            },
                            '&[data-dots]': {
                              outline: '0',
                              cursor: 'default !important',
                              opacity: '1 !important',
                              color: '#ffffff',
                            },
                            '&[aria-disabled]': {
                              outline: '0',
                              backgroundColor: '#666666',
                              opacity: '.65 !important',
                              color: '#ffffff',
                            },
                          },
                        }}
                        total={FEATURED_PAGE_COUNT}
                        initialPage={1}
                      />
                    </li>
                  </ul>
                </>
              </Tabs.Panel>
              <Tabs.Panel
                value="all"
                pt="xs"
                style={{
                  outline: '0',
                  height: '100%',
                }}
              >
                <>
                  <br />
                  <ul
                    className={classes.standardText + ' ' + classes.ulArticles}
                    style={{}}
                  >
                    {page == 1 ? (
                      <>
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE,
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_ES,
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_FR,
                                    SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML,
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_ES,
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_FR,
                              SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE,
                                    SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_ES,
                                    SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_FR,
                                    SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML,
                              SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_ES,
                              SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_FR,
                              SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    FIVE_MISTAKES_ARTICLE_ROUTE,
                                    FIVE_MISTAKES_ARTICLE_ROUTE_ES,
                                    FIVE_MISTAKES_ARTICLE_ROUTE_FR,
                                    FIVE_MISTAKES_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              FIVE_MISTAKES_TITLE_HTML,
                              FIVE_MISTAKES_TITLE_HTML_ES,
                              FIVE_MISTAKES_TITLE_HTML_FR,
                              FIVE_MISTAKES_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            FIVE_MISTAKES_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_TO_BUILD_ARTICLE_ROUTE,
                                    HOW_TO_BUILD_ARTICLE_ROUTE_ES,
                                    HOW_TO_BUILD_ARTICLE_ROUTE_FR,
                                    HOW_TO_BUILD_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_TO_BUILD_TITLE_HTML,
                              HOW_TO_BUILD_TITLE_HTML_ES,
                              HOW_TO_BUILD_TITLE_HTML_FR,
                              HOW_TO_BUILD_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_TO_BUILD_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                      </>
                    ) : page == 2 ? (
                      <>
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_MUSIC_BOOSTS_ARTICLE_ROUTE,
                                    HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_ES,
                                    HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_FR,
                                    HOW_MUSIC_BOOSTS_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_MUSIC_BOOSTS_TITLE_HTML,
                              HOW_MUSIC_BOOSTS_TITLE_HTML_ES,
                              HOW_MUSIC_BOOSTS_TITLE_HTML_FR,
                              HOW_MUSIC_BOOSTS_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_MUSIC_BOOSTS_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_FR,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_ES,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_FR,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_FR,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_ES,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_FR,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_ES,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_FR,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                      </>
                    ) : (
                      <>
                        <li className={classes.liArticle}>
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_MUCH_ARTICLE_ROUTE,
                                    HOW_MUCH_ARTICLE_ROUTE_ES,
                                    HOW_MUCH_ARTICLE_ROUTE_FR,
                                    HOW_MUCH_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_MUCH_TITLE_HTML,
                              HOW_MUCH_TITLE_HTML_ES,
                              HOW_MUCH_TITLE_HTML_FR,
                              HOW_MUCH_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_MUCH_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li
                          className={classes.liArticle}
                          style={{
                            visibility: 'hidden',
                          }}
                        >
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_FR,
                                    SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_ES,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_FR,
                              SPOTIFY_ISNT_LEGAL_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li
                          className={classes.liArticle}
                          style={{
                            visibility: 'hidden',
                          }}
                        >
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_FR,
                                    SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_ES,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_FR,
                              SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                        {width > 992 && (
                          <li
                            className={classes.liArticle}
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="50"
                                y="50"
                                width="100"
                                height="100"
                                fill="#FFFFFF"
                                transform="rotate(45 100 100)"
                              />
                            </svg>
                          </li>
                        )}
                        <li
                          className={classes.liArticle}
                          style={{
                            visibility: 'hidden',
                          }}
                        >
                          <span
                            className={classes.articleLink}
                            onClick={() => {
                              try {
                                props?.navigateRoute(
                                  translate(
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR,
                                    HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO,
                                    selectedLanguage,
                                  ),
                                )
                              } catch (e) {
                                if (DEBUG_MODE) console.log(e)
                              }
                            }}
                          >
                            {translate(
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_ES,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_FR,
                              HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_KO,
                              selectedLanguage,
                            )}
                          </span>
                          {getAttribution(
                            translate(
                              'Editor',
                              'Editora',
                              'Éditrice',
                              '편집자',
                              selectedLanguage,
                            ),
                            HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR,
                            selectedLanguage,
                            true,
                          )}
                        </li>
                      </>
                    )}
                    <li className={classes.liArticle}>
                      <br />
                      <Pagination
                        page={page}
                        sx={() => ({
                          '&:focus': {
                            outline: '0',
                          },
                        })}
                        onChange={(p: any) => {
                          try {
                            setFeaturedPage(1)
                            setPage(p)
                          } catch (e) {
                            if (DEBUG_MODE) console.log(e)
                          }
                        }}
                        styles={{
                          item: {
                            backgroundColor: '#b476eeff',
                            fontFamily: 'Arial, sans-serif',
                            color: '#ffffff',
                            borderColor: 'transparent',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            '&:hover': {
                              opacity: 0.85,
                            },
                            '&[data-active]': {
                              outline: '0',
                              cursor: 'default !important',
                              pointerEvents: 'none',
                              opacity: '1 !important',
                              fontFamily: 'Arial, sans-serif',
                              color: '#000000',
                              backgroundColor: '#339af0',
                            },
                            '&[data-dots]': {
                              outline: '0',
                              cursor: 'default !important',
                              opacity: '1 !important',
                              color: '#ffffff',
                            },
                            '&[aria-disabled]': {
                              outline: '0',
                              backgroundColor: '#666666',
                              opacity: '.65 !important',
                              color: '#ffffff',
                            },
                          },
                        }}
                        total={PAGE_COUNT}
                        initialPage={1}
                      />
                    </li>
                  </ul>
                </>
              </Tabs.Panel>
            </Tabs>
          </Grid.Col>
          <Grid.Col
            md={24}
            mt={width < 992 ? 0 : 114}
            pl={width < 370 ? 15 : 20}
            pr={width < 310 ? 5 : width < 370 ? 15 : 20}
          >
            <hr className={classes.threeDotDivisorBottomOfArticle} />
            <ReadyToTransform
              selectedLanguage={selectedLanguage}
              linkVariant={true}
            />
          </Grid.Col>
          <Grid.Col md={24}>
            <div>
              <br />
              <br />
              <br />
            </div>
          </Grid.Col>
        </Grid>
      </div>
    </div>
  )
}
